import { render, staticRenderFns } from "./SaveFilterDialog.vue?vue&type=template&id=2071a5af"
import script from "./SaveFilterDialog.vue?vue&type=script&lang=ts"
export * from "./SaveFilterDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports